import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import Select from '@mui/material/Select';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';   
import logoImage from './images/logo.jpg';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import psdfimage from './images/psdfimage.png';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';
function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export default class Balancereport extends Component {
    constructor(props) {
        super(props);

        const currentDate = new Date();

        var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
        var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();


        this.state = {
            redirect: false,
            ReportData: [],
			todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
           fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
                        fromdate1: currentDate.getFullYear() + '-' + month1 + '-' + '01',
            orderBy: '',
            order: 'asc',
			openExportDialog: false, 
        };
        this.componentRef = React.createRef();
    }

    componentDidMount() {
        document.title = "Profit and Loss Report - Comparative";
		
		  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
  this.apicall();			  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
       
		
		 this.props.parentdasCallback(
       "Profit and Loss Report - Comparative"
     );
    }
	
	
	PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=26')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.apicall();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}

    handleClickSearch = () => {
        this.apicall();
    }

   onchangedateHandler = (event) => {
        let selectedOption = event.target.value;
        const periodMap = {
            'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
            'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
            'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
            'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
            'Last Quarter': [dayjs().startOf('month').subtract(3, 'month'), dayjs().endOf('month')],
            'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
            'This Financial Year': [dayjs().startOf('year').add(3, 'month'), dayjs().endOf('year').add(3, 'month')],
            'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('year').add(2, 'month')],
            'Custom': [dayjs(), dayjs().endOf('month')]
        };

        if (selectedOption === 'Custom') {
            this.setState({
                fromdate: periodMap['Custom'][0],
                todate: periodMap['Custom'][1],
                fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
                todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
                fromDateEnabled: true,
                toDateEnabled: true
            });
        } else {
            this.setState({
                fromdate: periodMap[selectedOption][0],
                todate: periodMap[selectedOption][1],
                fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
                todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
                fromDateEnabled: false,
                toDateEnabled: false
            });
        }
    };

    fromdatehandler = (date) => {
        var month = "";
        var date1 = new Date(date);

        if ((date1.getMonth() + 1) < 10) {
            month = "0" + (date1.getMonth() + 1)
        } else { month = (date1.getMonth() + 1) }

        this.setState({
            fromdate: dayjs(date),
            fromdate1: date1.getFullYear() + '-' + month + '-' + date1.getDate(),
        })
    }

    todatehandler = (date) => {
        var month = "";
        var date1 = new Date(date);

        if ((date1.getMonth() + 1) < 10) {
            month = "0" + (date1.getMonth() + 1)
        } else { month = (date1.getMonth() + 1) }

        this.setState({
            todate: dayjs(date),
            todate1: date1.getFullYear() + '-' + month + '-' + date1.getDate(),
        })
    }

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

apicall() {

  axios.get(localStorage.getItem("ISIurl") + 'ajaxreports.php?action=comparative&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'))
    .then(resp => {
		
		
		
      let reportDataArray = [];
      if (Array.isArray(resp.data)) {
        reportDataArray = resp.data;
      } else if (resp.data && Array.isArray(resp.data.data)) {
        reportDataArray = resp.data.data;
      }


      this.setState({
        ReportData: resp.data,
      });
    })
 
}
handleDownload = () => {
    const { ReportData, order } = this.state;
    const doc = new jsPDF();

 
    const imgWidth = 40;
    const imgHeight = 12;
    const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
    const imgY = 10;
    doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight); 

    const title = 'Profit and Loss Report - Comparative';
    doc.setFontSize(16);
    const titleY = 20; 
    doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });

    const dateText = `Report Date: ${dayjs(this.state.fromdate).format('DD/MM/YYYY')}`;
    doc.setFontSize(10);
    doc.text(dateText, doc.internal.pageSize.width / 2, titleY + 7, { align: 'center' });

    let currentY = titleY + 20; 

  
    const groupedData = ReportData.reduce((acc, item) => {
        const category = item.le_category || 'Uncategorized';
        if (!acc[category]) {
            acc[category] = [];
        }
        const parsedBalance = parseFloat(item.total_balance || 0);
        item.total_balance = isNaN(parsedBalance) ? 0 : parsedBalance;
        acc[category].push(item);
        return acc;
    }, {});

    const tableHeaders = [['Account Code - Account Name', 'Balance']];

    const addCategoryToPdf = (categoryName, dataItems) => {
        if (dataItems.length > 0 && dataItems.some(item => item.total_balance !== 0)) {
            doc.setFontSize(12);
            doc.setFont(undefined, 'bold');
            doc.text(categoryName.toUpperCase(), 14, currentY);
            currentY += 5;

            const categoryRows = dataItems
                .filter(item => item.total_balance !== 0)
                .map(item => [
                    `${item.le_code} - ${item.le_ledgername}`,
                    parseFloat(item.total_balance).toFixed(2)
                ]);

            doc.autoTable({
                startY: currentY,
                head: tableHeaders,
                body: categoryRows,
                theme: 'grid',
                styles: { fontSize: 10, cellPadding: 2 },
                headStyles: { fillColor: [224, 224, 224], textColor: [0, 0, 0], fontStyle: 'bold' },
                columnStyles: { 1: { halign: 'right' } },
                didDrawPage: function () {
                    var str = "Page " + doc.internal.getNumberOfPages();
                    doc.setFontSize(10);
                    doc.text(str, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
                },
                margin: { left: 14, right: 14 }
            });

            currentY = doc.autoTable.previous.finalY + 5;

            const categorySum = dataItems.reduce((sum, item) => sum + item.total_balance, 0);
            if (categorySum !== 0) {
                doc.setFontSize(10);
                doc.setFont(undefined, 'bold');
                doc.text(`Total ${categoryName}`, 54, currentY, { align: 'left' });
                doc.text(categorySum.toFixed(2), doc.internal.pageSize.width - 14, currentY, { align: 'right' });
                doc.setFont(undefined, 'normal');
                currentY += 7;
            }
        }
    };

   
    Object.keys(groupedData).forEach(category => {
        addCategoryToPdf(category, groupedData[category]);
    });

  
    doc.save('BalanceReport.pdf');
    this.handleCloseExportDialog(); 
};


 getGroupedData = () => {
    const { ReportData } = this.state;
    if (!ReportData || ReportData.length === 0) return {};

    // Group by group -> category
    const grouped = ReportData.reduce((acc, item) => {
      const group = item.le_categorygroup || 'Ungrouped';
      const category = item.le_category || 'Uncategorized';

      if (!acc[group]) acc[group] = {};
      if (!acc[group][category]) acc[group][category] = [];
      acc[group][category].push(item);

      return acc;
    }, {});

    return grouped;
  };
  
  getColumns = (item) => Object.keys(item).filter(key => !['category', 'ledgername'].includes(key));

    render() {
        if (this.state.redirect === true) {
            return <Navigate to={this.state.pagename} />;
        }
 const groupedData = this.getGroupedData();
      
        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul>
                         <li>
                            <p>Period</p>
                            <p>
                                <Select
                                    native
                                    variant="outlined"
                                    className="txtbox"
                                    margin="normal"
                                    fullWidth
                                    onChange={this.onchangedateHandler}
                                    inputProps={{ tabIndex: '4' }}
                                >
                                    <option>This Month</option>
                                    <option>This Quarter</option>
                                    <option>This Year</option>
                                    <option>Last Month</option>
                                    <option>Last Quarter</option>
                                    <option>Last Year</option>
                                    <option>This Financial Year</option>
                                    <option>Last Financial Year</option>
                                    <option>Custom</option>
                                </Select>
                            </p>
                        </li>

                        <li>
                            <p>From Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        disabled={!this.state.fromDateEnabled}
                                        value={dayjs(this.state.fromdate)}
                                        className="txtbox"
                                        onChange={this.fromdatehandler}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>

                        <li>
                            <p>To Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        disabled={!this.state.toDateEnabled}
                                        value={dayjs(this.state.todate)}
                                        className="txtbox"
                                        onChange={this.todatehandler}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Calculate
                                </Button>
                                &nbsp;
								
								<Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
								
                               
                            </p>
                        </li>
                    </ul>
                    <div className="clear"></div>

                    <div ref={el => (this.componentRef = el)}>
					  <TableContainer component={Paper}>
            <Table size="small" id="balance-report-table">
              <TableBody>
                {Object.entries(groupedData).map(([group, categories]) => (
                  <TableRow key={group}>
                    <TableCell>
                      <div style={{ marginBottom: '30px' }}>
                        <Typography variant="h6" gutterBottom>{group}</Typography>

                        {Object.entries(categories).map(([category, ledgers]) => {
                          if (!ledgers || ledgers.length === 0) return null;

                          const dynamicCols = Object.keys(ledgers[0]).filter(
                            (k) => !['le_categorygroup', 'le_category', 'le_id', 'le_code', 'le_ledgername'].includes(k)
                          );

                          // Calculate category totals
                          const categoryTotals = {};
                          dynamicCols.forEach((col) => {
                            categoryTotals[col] = ledgers.reduce(
                              (sum, l) => sum + parseFloat(l[col] || 0),
                              0
                            );
                          });

                          return (
                            <div key={category} style={{ marginBottom: '20px' }}>
                              <Typography variant="subtitle1" gutterBottom>{category}</Typography>

                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                     
                                      <TableCell><b>Ledger</b></TableCell>
                                      {dynamicCols.map((col) => (
                                        <TableCell key={col} align="right">
                                          <b>{col.replace('_', ' ').toUpperCase()}</b>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {ledgers.map((ledger) => (
                                      <TableRow key={ledger.le_code}>
                                     
                                        <TableCell>{ledger.le_ledgername}</TableCell>
                                        {dynamicCols.map((col) => (
                                          <TableCell key={col} align="right">
                                            {parseFloat(ledger[col] || 0).toFixed(2)}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    ))}

                                    {/* Subtotal row */}
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                      <TableCell colSpan={1} sx={{ fontWeight: 'bold' }}>
                                        Total {category}
                                      </TableCell>
                                      {dynamicCols.map((col) => (
                                        <TableCell key={col} align="right" sx={{ fontWeight: 'bold' }}>
                                          {categoryTotals[col].toFixed(2)}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          );
                        })}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
	  
                    </div>
                </div>
				
				
				
				 <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed  Balance report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
				<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
				 <ReactHTMLTableToExcel
                                    variant="contained"
                                    color="primary"
                                    id="test-table-xls-button"
                                    className="my-custom-excel-button"
                                    table="balance-report-table"
                                    filename="Balance Report"
                                    sheet="Balance Report"
                                    buttonText=""
                                />
                         <img
    src={psdfimage}
    width={100}
    height={100}
    style={{ cursor: "pointer" }}
    onClick={this.handleDownload}
    alt="Download PDF"
  />
						
						</p>
						
						
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}
   export class fromtodate extends Component {
  constructor(props) {
    super(props);
    this.state = {
		   fromdate: props.fromdate || new Date(),
      todate: props.todate || new Date(),
      fromdate1: props.fromdate1 || '',
      todate1: props.todate1 || '',
    };
  }

onchangedateHandler = (event) => {
  let selectedOption = event.target.value;
  const periodMap = {
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
   'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
	 'This Financial Year': [dayjs().startOf('Year').add(3, 'month'), dayjs().endOf('Year').add(3, 'month')],
	 'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('Year').add(2, 'month')],
    'Custom':[dayjs(), dayjs().endOf('month')]
  };

if (selectedOption === 'Custom') {
    this.setState({
      fromdate: periodMap['Custom'][0],
      todate: periodMap['Custom'][1],
      fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
      todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
      fromDateEnabled: true,
      toDateEnabled: true
    });
  } else {
    this.setState({
      fromdate: periodMap[selectedOption][0],
      todate: periodMap[selectedOption][1],
      fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
      todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false
    });
  }
};


  
  
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
	
 this.setState({
    todate: dayjs(dateObj),
    todate1: dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate(),
    toDateEnabled: true
  });
 

  }
  


  render() {
 return (
	
	 <React.Fragment>
	 <div className="searchbox">

<ul>



	
<li>

<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.fromDateEnabled}
      value={dayjs(this.state.fromdate)}
      className="txtbox"
      onChange={this.fromdatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.toDateEnabled}
      value={dayjs(this.state.todate)}
      className="txtbox"
      onChange={this.todatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p></li>
	
	
	</ul>
	</div>
	 </React.Fragment>

  )}
   }